import React from 'react';
import { Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingContactActions = () => (
  <div className="fixed bottom-5 right-5 z-[60] flex flex-col gap-3 sm:bottom-6 sm:right-6">
    <a
      href="tel:+918610341454"
      aria-label="Call Aadvika Cabs at +91 86103 41454"
      title="Call Aadvika Cabs"
      className="flex h-14 w-14 items-center justify-center rounded-full bg-cyan-600 text-white shadow-lg shadow-cyan-900/25 transition duration-200 hover:scale-105 hover:bg-cyan-700 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cyan-300"
    >
      <Phone size={23} strokeWidth={2.5} aria-hidden="true" />
    </a>
    <a
      href="https://wa.me/918610341454?text=Hi%20Aadvika%20Cabs%2C%20I%20would%20like%20to%20book%20a%20cab."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message Aadvika Cabs on WhatsApp"
      title="Message Aadvika Cabs on WhatsApp"
      className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-green-900/25 transition duration-200 hover:scale-105 hover:bg-[#1fbd5b] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-green-300"
    >
      <FaWhatsapp size={29} aria-hidden="true" />
    </a>
  </div>
);

export default FloatingContactActions;
